import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Users from "../views/Users.vue";
import Surveys from "../views/Encuestas.vue";
import Alerts from "../views/Alerts.vue";
import Incidences from "../views/Incidences.vue";
import UserCard from "../views/components/UserCard.vue";
import Comments from "../views/Comments.vue";
import Rates from "../views/Rates.vue";
import Tabs from "../views/Web/Tabs.vue";
import Billing from "../views/Billing.vue";
import Bypasses from "../views/Bypasses.vue";
import BypassCard from "../views/components/BypassCard.vue";
import RateCard from "../views/components/RateCard.vue";
import Slider from "../views/Slider.vue";
import SliderCard from "../views/components/SliderCard.vue";
import Documents from "../views/Documents.vue";
import DocumentCard from "../views/components/DocumentCard.vue";
import Agreements from "../views/Agreements.vue";
import AgreementCard from "../views/components/AgreementCard.vue";
import Galleries from "../views/Galleries.vue";
import GalleryCard from "../views/components/GalleryCard.vue";
import ForgotPassword from "../auth/layouts/ForgotPassword.vue";
import RecoverPassword from "../auth/layouts/RecoverPassword.vue";
//import VirtualReality from "../views/VirtualReality.vue";
// import Profile from "../views/Profile.vue";
// import Signup from "../views/Signup.vue";
//import Signin from "../auth/layouts/Signin.vue";
import AuthRouter from "../auth/router"
import Meta from "../views/Web/Main.vue";
import PrivacyPolicies from "../views/Web/PoliticaPrivacidad.vue";
// import Waze from "../views/Web/Waze.vue";
import isAuthenticatedGuard from "../auth/router/auth-guard";
import isAuthenticatedGuardAuxilio from "../auth/router/auth-guard-auxilio";
import isAuthenticatedGuardUsers from "../auth/router/auth-guard-users";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/meta",
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: "/recover-password",
    name: "RecoverPassword",
    component: RecoverPassword,
    props: route => ({ resetPasswordToken: route.query.reset_password_token })
  },
  {
    path: "/meta",
    name: "Meta",
    component: Meta,
  },
  {
    path: "/privacy-policies",
    name: "PrivacyPolicies",
    component: PrivacyPolicies,
  },
  // {
  //   path: "/meta/waze",
  //   name: "waze",
  //   component: Waze,
  // },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    beforeEnter: [isAuthenticatedGuard],
    component: Dashboard,
  },
  {
    path: "/tables",
    name: "Tables",
    beforeEnter: [isAuthenticatedGuard],
    component: Tables,
  },
  {
    path: "/billing",
    name: "Billing",
    beforeEnter: [isAuthenticatedGuard],
    component: Billing,
  },
  {
    path: "/bypasses",
    name: "Bypasses",
    beforeEnter: [isAuthenticatedGuard],
    component: Bypasses,
  },
  {
    path: "/bypass-card/:bypassID",
    name: "BypassCard",
    beforeEnter: [isAuthenticatedGuard],
    component: BypassCard,
    props: route => ({
      bypassID: !isNaN(parseInt(route.params.bypassID)) ?
        parseInt(route.params.bypassID) > 0 ?
          route.params.bypassID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/Tabs/:bypassID/:title",
    name: "Tabs",
    beforeEnter: [isAuthenticatedGuard],
    component: Tabs,
    props: route => ({
      bypassID: route.params.bypassID,
      title: route.params.title
    })
  },
  {
    path: "/rates/:bypassID/:title",
    name: "Rates",
    beforeEnter: [isAuthenticatedGuard],
    component: Rates,
    props: route => ({
      bypassID: route.params.bypassID,
      title: route.params.title
    })
  },
  {
    path: "/rate-card/:bypassID/:rateID",
    name: "RateCard",
    beforeEnter: [isAuthenticatedGuard],
    component: RateCard,
    props: route => ({
      bypassID: !isNaN(parseInt(route.params.bypassID)) ?
        parseInt(route.params.bypassID) > 0 ?
          route.params.bypassID
          :
          '0'
        :
        '0',
      rateID: !isNaN(parseInt(route.params.rateID)) ?
        parseInt(route.params.rateID) > 0 ?
          route.params.rateID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/slider",
    beforeEnter: [isAuthenticatedGuard],
    name: "Slider",
    component: Slider,
  },
  {
    path: "/slider-card/:sliderID",
    name: "SliderCard",
    beforeEnter: [isAuthenticatedGuard],
    component: SliderCard,
    props: route => ({
      sliderID: !isNaN(parseInt(route.params.sliderID)) ?
        parseInt(route.params.sliderID) > 0 ?
          route.params.sliderID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/documents",
    beforeEnter: [isAuthenticatedGuard],
    name: "Documents",
    component: Documents,
  },
  {
    path: "/document-card/:documentID",
    name: "DocumentCard",
    beforeEnter: [isAuthenticatedGuard],
    component: DocumentCard,
    props: route => ({
      documentID: !isNaN(parseInt(route.params.documentID)) ?
        parseInt(route.params.documentID) > 0 ?
          route.params.documentID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/agreements",
    name: "Agreements",
    beforeEnter: [isAuthenticatedGuard],
    component: Agreements,
  },
  {
    path: "/agreement-card/:agreementID",
    name: "AgreementCard",
    beforeEnter: [isAuthenticatedGuard],
    component: AgreementCard,
    props: route => ({
      agreementID: !isNaN(parseInt(route.params.agreementID)) ?
        parseInt(route.params.agreementID) > 0 ?
          route.params.agreementID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/galleries",
    name: "Galleries",
    beforeEnter: [isAuthenticatedGuard],
    component: Galleries,
  },
  {
    path: "/gallery-card/:galleryID",
    name: "GalleryCard",
    beforeEnter: [isAuthenticatedGuard],
    component: GalleryCard,
    props: route => ({
      galleryID: !isNaN(parseInt(route.params.galleryID)) ?
        parseInt(route.params.galleryID) > 0 ?
          route.params.galleryID
          :
          '0'
        :
        '0'
    })
  },

  // {
  //   path: "/virtual-reality",
  //   name: "Virtual Reality",
  //   component: VirtualReality,
  // },
  // {
  //   path: "/profile",
  //   name: "Profile",
  //   component: Profile,
  // },
  // {
  //   path: "/signin",
  //   name: "Signin",
  //   component: Signin,
  // },
  // {
  //   path: "/signup",
  //   name: "Signup",
  //   component: Signup,
  // },
  {
    path: "/comments",
    name: "Comments",
    beforeEnter: [isAuthenticatedGuardUsers],
    component: Comments,
    props: route => ({
      commentID: !isNaN(parseInt(route.params.commentID)) ?
        parseInt(route.params.commentID) > 0 ?
          route.params.commentID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/users",
    name: "Users",
    beforeEnter: [isAuthenticatedGuardUsers],
    component: Users,
  },
  {
    path: "/user-card/:userID",
    name: "UserCard",
    beforeEnter: [isAuthenticatedGuardUsers],
    component: UserCard,
    props: route => ({
      userID: !isNaN(parseInt(route.params.userID)) ?
        parseInt(route.params.userID) > 0 ?
          route.params.userID
          :
          '0'
        :
        '0'
    })
  },
  {
    path: "/alerts",
    name: "Alerts",
    beforeEnter: [isAuthenticatedGuardAuxilio],
    component: Alerts,
  },

  {
    path: "/incidences",
    name: "Incidences",
    beforeEnter: [isAuthenticatedGuardAuxilio],
    component: Incidences,
  },
  {
    path: "/surveys",
    name: "Surveys",
    beforeEnter: [isAuthenticatedGuardUsers],
    component: Surveys,
  },
  {
    path: '/signin',
    ...AuthRouter
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/meta' 
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
